export default {
    PreoccupationManagement: {
        Doc: '单号',
        Channel: '渠道',
        Store: '店铺',
        Pre: '预占状态',
        Three: '三方下单时间',
        Start: '开始日期',
        End: '结束日期',
        Internal: 'ERP创单时间',
        form: {
            Third: '客户订单号',
            Internal: '内部订单号',
            code: '预占编码',
            status: '预占状态',
            category: '商品种类',
            number: '商品行总数',
            reserved: '待预占',
            succeeded: '预占成功',
            failed: '预占失败',
            store: '销售店铺',
            channel: '销售渠道',
            Three: '三方下单时间',
            order: 'ERP创单时间',
            time: '预计发货时间',
            Operation: '操作',
        },
        view: {
              information: '基本信息',
              reserve: '重新预占',
              preemptTitle: '预占商品信息',
              confirmText: '重新预占 此订单'
        }
        }
};
